import React, { useEffect, useState } from 'react';
import { GetViewType } from "../../../utils/view-type";
import useDirection from "../../../hooks/useDirection";
import { useTranslation } from "react-i18next";
import Sort from "../../sort/sort";
import Search from "../../search/search";
import { DeleteIcon, EditIcon } from "../../../icons/icons";
import Filter from "../../filter/filter";
import DropDown from "../../../assets/dropDown/dropDown";
import Pagination from "../../pagination/pagination";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Get } from "../../../apis/api";
import { setting } from "../../../store/setting/setting.reducer";
import { toast } from "react-toastify";
import { Separate } from "../../../utils/separate";
import LoadingFix from "../../loading-fix/loading-fix";
import { useQuery } from 'react-query';
import { ListResponseType, TransactionItemType } from 'src/types';
import moment from 'moment-jalaali';
import { TransactionRow } from './components/TransactionRow';

export const NewTransactionsTable = ({ defaultValue, editItem }: { defaultValue: any, editItem: any }) => {
    const viewType = GetViewType()
    const directionClass = useDirection();
    const { t } = useTranslation();
    const [perPage, setPerPage] = useState(12)
    const dispatch = useDispatch()
    const [page, setPage] = useState<number>(1)



    const { data: allData, isLoading, refetch } = useQuery<{}, {}, ListResponseType<TransactionItemType>>({
        queryFn: ({ queryKey }) => Get(`/admin/transactions/settlement?page=${queryKey[1]}&per_page=${queryKey[2]}`),
        queryKey: ['GetTransactions', page, perPage]
    })

    const transacions = allData?.details.data.data

    const pureData = allData?.details.data


    //   useEffect(() => {
    //     if( user?.role_key === "client" || user?.role_key === "agent") {
    //       handleList()
    //       handleLog()
    //     }

    //   } ,[])

    // useEffect(() => {
    //     setData(defaultValue)
    // }, [defaultValue])

    //   const handleList = (page , per_page , search="") => {
    //     setLoading(true)
    //     Get(`agent/transactions?page=${page || 1}&per_page=${per_page || 10}&q=${search}` ).then((res) =>{
    //       setData(res?.details?.data)
    //     }).finally(() => {
    //       setLoading(false)
    //     })
    //   }

    //   const handleLog = (page , per_page , search="") => {
    //     setLoading(true)
    //     Get(`agent/transactions/wallets/log` ).then((res) =>{
    //       setWalletLog(res?.details?.data)
    //     }).finally(() => {
    //       setLoading(false)
    //     })
    //   }


    //   const handleEdit = (item) => {
    //     editItem(item)
    //   }

    //   const handleDelete = (item) => {
    //     setDeleteItem(item)
    //   }

    //   const handleCloseDeleteModal = () => {
    //     setDeleteItem(null)
    //   }

    //   const handleDeleteRequest = () => {
    //     setLoadingDelete(true)
    //     Delete(`basic-information/province/destroy/${deleteItem}` ).then((res) =>{
    //       setData(res?.details?.data)
    //       dispatch(setting({province : res?.details?.data?.data}))
    //       toast.success(res.msg)
    //       setDeleteItem(null)
    //     }).finally(() => {
    //       setLoadingDelete(false)
    //     })
    //   }
    //   const handleSort = (e) => {
    //     setData([])
    //     setTimeout(() => {
    //       setData(e)
    //     } ,0)
    //   }

    //   const handleSearch = (e) => {

    //     clearTimeout(searchTime)


    //     let loop = setTimeout(() => {

    //       handleList(1 , perPage , e);

    //     }, 1000)
    //     setSearchTime(loop)

    //   }

    return (
        <div>
            {
                isLoading && <LoadingFix />
            }
            {/* {
                viewType === "WEB" ? */}
            <div className="relative overflow-x-auto   bg-white rounded-lg  flex flex-col lg:items-center w-full  border border-1 border-gray-300 overflow-hidden ">
                <table className="w-full text-sm text-gray-500" cellPadding={12} cellSpacing={4}>
                    <thead className="text-xs text-gray-700 uppercase ">
                        <tr className={"border-b border-gray-400 [&>th]:text-center"}>
                            <th scope="col" className="px-6 py-3 w-4 font-normal text-gray-600 text-sm">
                                <div className={"mt-1"}>
                                    {t("row")}
                                </div>
                            </th>
                            <th scope="col" className="px-6 py-3  w-4 font-normal text-gray-600 text-sm">
                                <div className={"mt-1"}>
                                    {t("agent")}
                                </div>
                            </th>
                            <th scope="col" className="px-6 py-3   font-normal text-gray-600 text-sm">
                                {/* <div className={"mt-1 flex"}> */}
                                {/* <Sort data={data} sortKey={"amount"}  onSort={(e)=> handleSort(e)}/> */}
                                {t("amount")}
                                {/* </div> */}
                            </th>
                            <th scope="col" className="pr-6 py-3 font-normal text-gray-600 text-sm ">
                                {/* <div className={"mt-1 flex"}> */}
                                {/* <Sort data={data} sortKey={"amount"}  onSort={(e)=> handleSort(e)}/> */}
                                {t("Description")}
                                {/* </div> */}
                            </th>

                            <th scope="col" className="pr-6 py-3 font-normal text-gray-600 text-sm ">
                                {t('AttachedFile')}
                            </th>


                            <th scope="col" className="pr-6 py-3  font-normal text-gray-600 text-sm ">
                                {t('PayDate')}
                            </th>


                            <th scope="col" className="pr-6 py-3  font-normal text-gray-600 text-sm ">
                                {t('PayType')}
                            </th>

                            <th scope="col" className="px-4 py-3  font-normal text-gray-600 text-sm ">
                                {/* <div className={`mt-1 flex ${directionClass ? "justify-center" : "justify-center"}`}> */}
                                {/* <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/> */}
                                {t("status")}
                                {/* </div> */}
                            </th>

                            <th scope="col" className="pr-6 py-3  font-normal text-gray-600 text-sm ">
                                {t('Operation')}
                            </th>
                            {/*<th scope="col" className=" py-3 text-left font-normal text-gray-600 text-sm ">
                                        <div className={`mt-1 flex ${directionClass ? "justify-center" : "justify-center"}`}>
                                            {t("visaNumber")}
                                        </div>
                                    </th>
                                    <th scope="col" className="pl-12 py-3 text-left font-normal text-gray-600 text-sm ">
                                        <div className={`mt-1 flex ${directionClass ? "justify-end" : "justify-start"}`}>
                                           <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/> 
                                            {t("paymentCode")}
                                        </div>
                                    </th>*/}

                        </tr>
                    </thead>
                    <tbody>
                        {transacions?.map((item, index) => <TransactionRow refetch={refetch} {...item} />)}
                    </tbody>
                </table>
            </div>

            <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
                <DropDown onChange={(per_page: number) => {
                    //   handleList(1, per_page)
                    setPerPage(per_page)
                }} />
                <Pagination forcePage={page - 1} itemsPerPage={pureData?.per_page} total={pureData?.total} last_page={pureData?.last_page} changePage={(page: number) => setPage(page)} />
            </div>
        </div>
    );
};


// :
// <div className={"grid gap-3 "}>
//     <div className={"bg-white p-3 rounded-lg flex gap-5"}>
//         <Filter />
//         {/* <div className={"w-full"}>
//             <Search onChange={handleSearch} />
//         </div> */}
//     </div>
//     {
//         // data?.data?.map((item) => {
//         //     return (
//         //         <div className={"flex p-4 rounded-lg bg-white"}>
//         //             <div className={"flex w-full"}>
//         //                 <div className={"ml-1 min-w-7"}>{item.row}</div>
//         //                 <div className={"flex w-full flex-wrap gap-y-8 justify-between items-center"}>
//         //                     <div className={"flex w-1/2 text-base text-primary-400"}>{Separate(item.amount)}</div>
//         //                     <div className={"flex w-1/2 text-sm justify-end"}>{item.item_id}</div>
//         //                     <div className={"flex w-full justify-between items-center"}>
//         //                         <div>
//         //                             {/* {handleStatus(item.status)} */}
//         //                         </div>
//         //                         <div className={"flex items-center  text-sm "}>
//         //                             <span className={"text-xs"}>
//         //                                 شماره درخواست :
//         //                             </span>
//         //                             <div>
//         //                                 {item.transaction_id}
//         //                             </div>
//         //                         </div>
//         //                     </div>
//         //                 </div>
//         //             </div>

//         //         </div>
//         //     )
//         // })
// //     }
// // </div>
// // }